<template>
  <button
    type="button"
    class="inline-flex items-center gap-2 py-0.5 px-4 rounded border text-base"
    :class="{
      'bg-primary-50 text-primary cursor-pointer hover:bg-primary-100':
        !disabled,
      'bg-gray-300 text-gray-500 pointer-events-none':
        disabled,
    }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span v-if="title">{{ title }}</span>
    <span v-else-if="$slots.default">
      <slot />
    </span>
    <font-awesome-icon
      icon="chevron-down"
      class="text-main text-sm"
      :class="{
        'text-primary': !disabled,
        'text-gray-500': disabled,
      }"
    />
  </button>
</template>

<script>
export default {
  props: {
    title: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  }
};
</script>

<style lang="scss" scoped>
</style>